import { cx } from "@emotion/css";
import ScrollLayout from "library/Layouts/ScrollLayout";
import { PropTypes } from "prop-types";
import styles from "./styles";

const ModalLayout = ({ className, children, descriptionSection, modalControls, modals, ...restProps }) => (
  <>
    <ScrollLayout className={cx(className, styles.modalContent)} {...restProps}>
      {descriptionSection && <p className="mb-4 text-justify">{descriptionSection}</p>}

      {children}
    </ScrollLayout>

    {modalControls && (
      <div className="d-flex flex-column align-items-center gap-4 mt-4 px-0 w-100">{modalControls}</div>
    )}

    {modals}
  </>
);

ModalLayout.defaultProps = {
  className: null,
  descriptionSection: null,
  modals: null,
};

ModalLayout.propTypes = {
  className: PropTypes.string,
  descriptionSection: PropTypes.node,
  children: PropTypes.node.isRequired,
  modalControls: PropTypes.node.isRequired,
  modals: PropTypes.node,
};

export default ModalLayout;
